// extracted by mini-css-extract-plugin
export default {"body":"ProtocolModal_body__LF4e9","header":"ProtocolModal_header__3XHLz"};